var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129.09 115.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1818;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:none;}.cls-2{fill:#ffc200;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 129.09,
    height: 115.46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    transform: "translate(-7.938 -12.097)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374-2",
    transform: "translate(7.938 12.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46677",
    className: "cls-2",
    d: "M76.51,6.89l50.72,87.85c3.8,6.63,1.51,15.09-5.12,18.89-2.08,1.2-4.44,1.83-6.85,1.83H13.83C6.18,115.44,0,109.23,.03,101.59c0-2.4,.64-4.76,1.83-6.84L52.58,6.89C56.41,.29,64.88-1.96,71.49,1.87c2.08,1.21,3.82,2.94,5.02,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46678",
    className: "cls-1",
    d: "M72.02,9.49l50.72,87.85c2.39,4.12,.99,9.39-3.12,11.79-1.32,.77-2.83,1.17-4.35,1.17H13.82c-4.76,.01-8.63-3.84-8.64-8.6,0-1.53,.4-3.04,1.17-4.36L57.06,9.49c2.4-4.13,7.69-5.54,11.82-3.14,1.3,.76,2.38,1.84,3.14,3.14m-4.49,2.59c-.96-1.65-3.08-2.21-4.73-1.25-.52,.3-.95,.73-1.25,1.25L10.83,99.92c-.96,1.64-.42,3.74,1.22,4.71,.54,.32,1.15,.48,1.77,.47H115.26c1.9,.02,3.45-1.51,3.47-3.41,0-.62-.16-1.24-.47-1.77L67.54,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46679",
    className: "cls-1",
    d: "M64.54,85.36c3.08,0,5.58,2.5,5.58,5.58s-2.5,5.58-5.58,5.58-5.58-2.5-5.58-5.58,2.5-5.58,5.58-5.58h0m4.99-53.1c1.75,1.82,1.73,2.65,1.65,4.31l-2.1,41.33c-.25,4.87-8.84,4.87-9.08,0l-2.1-41.33c-.09-1.61,.5-3.18,1.64-4.31,2.34-2.43,8.24-1.82,9.99,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8ae5ec629213efcdaff2f4ed9088291f.svg";
export { ForwardRef as ReactComponent };